"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Conversation = _interopRequireDefault(require("composer-lib/data/model/Conversation"));

var _FormattedHTMLMessage = _interopRequireDefault(require("I18n/components/FormattedHTMLMessage"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _react = _interopRequireDefault(require("react"));

var defaultOnClickHandler = function defaultOnClickHandler(ev) {
  ev.preventDefault();
};

var _default = (0, _createReactClass.default)({
  displayName: "RemoveConversation",
  propTypes: {
    conversation: _propTypes.default.instanceOf(_Conversation.default).isRequired,
    deleteConversation: _propTypes.default.func.isRequired,
    deleting: _propTypes.default.bool,
    isPendingConversation: _propTypes.default.bool,
    showDeleteConfirm: _propTypes.default.func
  },
  getInitialState: function getInitialState() {
    return {
      confirmOpen: false
    };
  },
  componentDidUpdate: function componentDidUpdate(prevProps, prevState) {
    var confirmOpen = this.state.confirmOpen;

    if (confirmOpen !== prevState.confirmOpen) {
      this.props.showDeleteConfirm(confirmOpen);
    }
  },
  onRemoveClick: function onRemoveClick() {
    this.setState({
      confirmOpen: true
    });
  },
  onRemoveConfirm: function onRemoveConfirm() {
    this.props.deleteConversation(this.props.conversation);
  },
  onRemoveCancel: function onRemoveCancel() {
    this.setState({
      confirmOpen: false
    });
  },
  getOnClickHandler: function getOnClickHandler(handler) {
    if (this.props.deleting) {
      return defaultOnClickHandler;
    }

    return handler;
  },
  anchorClassNames: function anchorClassNames(name) {
    var _cx;

    return (0, _classnames.default)((_cx = {}, (0, _defineProperty2.default)(_cx, "remove-" + name, true), (0, _defineProperty2.default)(_cx, "disabled", this.props.deleting), _cx));
  },
  renderRemoveForPendingConversation: function renderRemoveForPendingConversation() {
    return _react.default.createElement("a", {
      className: this.anchorClassNames('title'),
      onClick: this.getOnClickHandler(this.onRemoveConfirm),
      role: "button"
    }, _react.default.createElement(_FormattedHTMLMessage.default, {
      message: "composer-lib.conversations.remove.titlePendingConversation"
    }));
  },
  renderRemovePrompt: function renderRemovePrompt() {
    return _react.default.createElement("a", {
      className: this.anchorClassNames('title'),
      onClick: this.getOnClickHandler(this.onRemoveClick),
      role: "button"
    }, _react.default.createElement(_FormattedHTMLMessage.default, {
      message: "composer-lib.conversations.remove.title"
    }));
  },
  renderRemoveConfirm: function renderRemoveConfirm() {
    return _react.default.createElement("span", null, _react.default.createElement("a", {
      className: this.anchorClassNames('confirm'),
      onClick: this.getOnClickHandler(this.onRemoveConfirm),
      role: "button"
    }, _react.default.createElement(_FormattedHTMLMessage.default, {
      message: "composer-lib.conversations.remove.confirm"
    })), _react.default.createElement("a", {
      className: this.anchorClassNames('cancel'),
      onClick: this.getOnClickHandler(this.onRemoveCancel),
      role: "button"
    }, _react.default.createElement(_FormattedHTMLMessage.default, {
      message: "composer-lib.conversations.remove.cancel"
    })));
  },
  renderRemoveText: function renderRemoveText() {
    if (this.props.isPendingConversation) {
      return this.renderRemoveForPendingConversation();
    }

    if (this.state.confirmOpen) {
      return this.renderRemoveConfirm();
    }

    return this.renderRemovePrompt();
  },
  render: function render() {
    return _react.default.createElement("div", {
      className: "remove-conversation"
    }, this.renderRemoveText());
  }
});

exports.default = _default;
module.exports = exports.default;